<template>
  <div id="app">
    <router-view v-if="isReloadAlive"></router-view>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapState, mapMutations, mapActions } from 'vuex'
import { userService } from '@/common/api'
import { cookieSet } from '@/common/cookie'
import { messages } from '@/i18n'
export default {
  name: 'app',
  watch: {
    '$i18n.locale': 'i18nHandle'
  },
  provide() {
    return {
      reload: this.reload,
      setAsideFlag: this.setAsideFlag
    }
  },
  computed: {
    ...mapState('d2admin/menu', [
      'aside',
      'asideTransition'
    ])
  },
  created () {
    this.i18nHandle(this.$i18n.locale)
    this.recordOriginalMenu(this.flushUnauditUserCount)
  },
  data() {
    return {
      isReloadAlive: true,
      asideBak: []
    }
  },
  methods: {
    ...mapMutations('d2admin/menu', ['asideSet']),
    i18nHandle (val, oldVal) {
      cookieSet('language', val)
      document.querySelector('html').setAttribute('lang', val)
      document.title = messages[val].brand.lg
      // 非登录页面，切换语言刷新页面
      if (this.$route.name !== 'login' && oldVal) {
        window.location.reload()
      }
    },
    reload() {
			this.isReloadAlive = false
			this.$nextTick(function(){
				this.isReloadAlive = true
			})
    },
    recordOriginalMenu(callback) {
      this.interval = setInterval(() => {
        if (!this.asideBak || this.asideBak.length < 1) {
          this.asideBak = cloneDeep(this.aside)
        } else {
          clearInterval(this.interval)
          callback();
        }
      }, 1000)
    },
    flushUnauditUserCount() {
      userService.getUncheckCount().then(res => {
        this.setAsideFlag('member-listReview', '<font class="menu-hint-count">(' + res.data.count + ')</font>')
      })
    },
    setAsideFlag(menuPath, flag) {
      let searchMenu;
      let menus = []
      searchMenu = (m, ) => {
        for (let i in m) {
          if (menuPath == m[i].name) {
            menus.push(m[i])
          }
          if (m[i].children) {
            searchMenu(m[i].children)
          }
        }
      }

      let aside = cloneDeep(this.asideBak)
      searchMenu(aside)
      if (menus && menus.length > 0) {
        for (let i in menus) {
          let menu = menus[i]
          menu.title = menu.title + flag
        }
        this.asideSet(aside)
      }

    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/style/public-class.scss';
.menu-hint-count {
  color: red;
  margin-left: 5px;
  position: absolute;
}
</style>
